import { Severity } from '@sentry/types';
import { JsonMap } from '@gh/ts-utils';

export interface SentryMessageOptions {
  level: Severity;
  tags?: { [key: string]: string };
}

export interface SLOEvent<T> {
  name: string;
  metadata: T;
}

export interface TelemetryEventData {
  type: string;
  payload?: JsonMap;
}

export enum FlowSLOPayloadResolution {
  START = 'START',
  END_ERROR = 'END_ERROR',
  END_CONFIRMATION = 'END_CONFIRMATION',
}

export interface FlowSLOPayload {
  order_id: string;
}

export interface Monitor {
  reportError?(error: Error): void;
  moduleReady?(moduleName: string): void;
  setPageAttribute?(pageName: string): void;
  initializeUser?(): void;
  captureMessage?(message: string, options?: SentryMessageOptions): void;
  sendSLOStartingEvent?<T>(sloEvent: SLOEvent<T>): void;
  sendSLOEndingEvent?<T>(sloEvent: SLOEvent<T>): void;
}
export interface MonitorManager extends Monitor {
  reportError(error: Error): void;
  moduleReady(moduleName: string): void;
  setPageAttribute(pageName: string): void;
  initializeUser(): void;
  captureMessage(message: string, options?: SentryMessageOptions): void;
  sendSLOStartingEvent<T>(sloEvent: SLOEvent<T>): void;
  sendSLOEndingEvent<T>(sloEvent: SLOEvent<T>): void;
}
